import React from "react";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import styles from "./styles.css";
import CloseButton from "../../shared/icon-cross";
import RepairIcon from "./images/repair-icon.svg";
import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";

const ServiceHistoryRevampModal = ({config, content = {}, onClose}) => {
    const {carHistory = {}, serviceHistory = []} = content;
    const {imageHost} = config || {};
    const serviceHistoryImage = carHistory?.serviceHistoryImage;

    const imageUrl = (path) => fastlyUrl(imageHost, path, imageTypes.aeCarDetailPreview);
    return (
        <React.Fragment>
            <Modal isOpen={true}>
                <div styleName={"styles.outer"}>
                    <div styleName={"styles.headerWrap"}>
                        <p>Full Service History</p>
                        <span styleName={"styles.close"}><CloseButton type={"grey"} onClickHandler={onClose}/></span>
                    </div>
                    <div styleName={"styles.contentWrap"}>
                        <p styleName={"styles.subHeading"}>The service history recorded for this vehicle is shown below. If the car presents with low kilometres, it may not have been serviced yet. If there are no service history records available, you may only see details of the service carried out by CARS24.</p>
                        <p styleName="styles.seviceCount"><img src={RepairIcon}/>{ (serviceHistory?.length || 0) + (serviceHistory?.length >1 ? " Past services" : " Past service") } </p>
                        <div styleName={"styles.contentContainer"}>

                            <div styleName="styles.serviceHistoryTimelineWrapper">
                                {serviceHistory.map(({serviceDate, postService = {}, serviceCenterAddress}, index) =>
                                    (
                                        <div key={index} styleName={"styles.recentServiceSectionWrap"}>
                                            <div styleName={"styles.dateWrapper"}>
                                                <p styleName={"styles.serviceDate"}>{serviceDate}</p>
                                                {postService.odo && <p styleName={"styles.kmWrapper"}>{postService.odo} Km</p>}
                                            </div>
                                            <p styleName={"styles.serviceCenterAddress"}>{serviceCenterAddress}</p>
                                        </div>
                                    )
                                )}
                            </div>
                            <div styleName="styles.serviceHistoryImageSection">
                                {serviceHistoryImage && <img src={imageUrl(serviceHistoryImage)} />}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
};

ServiceHistoryRevampModal.propTypes = {
    onClose: PropTypes.func,
    config: PropTypes.object,
    content: PropTypes.func
};

export default ServiceHistoryRevampModal;
